export const CHANGE_THEME_REQUEST = "changeThemeReducer/CHANGE_THEME_REQUEST";
